export const getCurrentSession = () => {
  const year = new Date().getFullYear();
  return `${year}-${year + 1}`;
};

export const currentSession = getCurrentSession();
